import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTable } from '@angular/material/table';
import { DataTableRequest } from 'src/app/models/datatable-request';
import { DialogData } from 'src/app/models/dialog-data';
import { Regulation } from 'src/app/models/regulation';
import { DownloadService } from 'src/app/services/download/download.service';
import { RegulationService } from 'src/app/services/regulasi/regulation.service';
import { TokenStorageService } from 'src/app/services/token-storage/token-storage.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { PreviewComponent } from '../preview/preview.component';
import { FormRegulasiComponent } from './form-regulasi/form-regulasi.component';

@Component({
  selector: 'app-regulasi',
  templateUrl: './regulasi.component.html',
  styleUrls: ['./regulasi.component.css']
})
export class RegulasiComponent implements OnInit {
  @ViewChild('paginator') paginator: MatPaginator | undefined;
  dataSource: Regulation[] = [];
  displayedColumns: string[] = ['title', 'category-id', 'upload-date', 'filename', 'action'];
  page = 0;
  searchTerm = '';
  length = 0;
  pageSize = 20;
  pageSizeOptions: number[] = [20, 50, 100];
  pageEvent: PageEvent | undefined;

  @ViewChild(MatTable)
  table!: MatTable<Regulation>;
  isLoading = false;

  constructor(public dialog: MatDialog,
    public downloadService: DownloadService,
    public tokenStorageService: TokenStorageService,
    private regulationService: RegulationService,) { }

  ngOnInit(): void {
    this.reload();
  }

  search() {
    this.page = 0;
    this.paginator?.firstPage();
    this.length = 0;
    this.reload();
  }

  reload(event?: PageEvent) {
    const payload: DataTableRequest = {
      page: event ? event.pageIndex : this.page,
      dataPerPage: event ? event.pageSize : this.pageSize,
      searchTerm: this.searchTerm,
    };
    this.getRegulasiList(payload);
  }

  openDialog(regulation?: Regulation) {
    const dialogRef = this.dialog.open(FormRegulasiComponent, {
      data: regulation,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        this.reload();
      }
    });
  }

  preview(viewerUrl: string, url: string) {
    const dialogRef = this.dialog.open(PreviewComponent, {
      data: {
        viewerUrl: viewerUrl,
        url: url,
        isPdf: true,
      },
      maxWidth: '90vw',
      maxHeight: '90vh',
      height: '100%',
      width: '100%',
      panelClass: 'full-width-height-dialog',
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }

  confirmDialog(regulation: Regulation) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: <DialogData>{
        title: 'Peringatan',
        message: 'Apakah Anda yakin akan menghapus data ini?',
        isConfirmation: true,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && regulation.id != undefined) {
        this.regulationService.delete(regulation.id).subscribe(() => {
          this.reload();
        });
      }
    });
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions = setPageSizeOptionsInput
        .split(',')
        .map((str) => +str);
    }
  }

  private getRegulasiList(payload: DataTableRequest) {
    this.isLoading = true;
    this.regulationService.getListAll(payload).subscribe((response) => {
      this.table.renderRows();
      this.dataSource = response.regulations;
      this.length = response.total;
      this.page = response.page;
      this.isLoading = false;
    });
  }
}
